import onTrackingReady from '../common/on-tracking-ready';
import { LaunchReady } from './launch-tracking';

export default () => {
  onTrackingReady(() => {
    LaunchReady();
  });
};
